import { get } from 'lodash';
import { connect } from 'react-redux';

import { actions } from 'Data/actions';
import InviteForm from './component';

export default connect((state) => ({
  isCreatingMeeting: get(state, ['Meeting', 'isCreatingMeeting']),
  isFetchingPatientContactDetails: get(state, ['Meeting', 'isFetchingPatientContactDetails']),
  incomingPatientEmail: get(state, ['Meeting', 'patientContactDetails', 'email'], ''),
  incomingPatientMobile: get(state, ['Meeting', 'patientContactDetails', 'mobile'], ''),
  incomingPatientShowError: get(state, ['Meeting', 'dataBridgeShowError'], false),
}), (dispatch) => ({
  meetingCreate: (patientMobile, payloadKey) => dispatch(actions.meetingCreate(patientMobile, payloadKey)),
  meetingPutPatientDetails: (code) => dispatch(actions.meetingPutPatientDetails(code)),
}))(InviteForm);
